module.exports = __webpack_public_path__ + "static/media/signage-indoor-img50.8b3cb183.jpg";